import React from 'react';
import { AppBar, Toolbar, IconButton, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import RefreshIcon from '@mui/icons-material/Refresh';
import ConnectionStatus from './ConnectionStatus';

function Header({
  showMenuButton = true,
  onRefreshClick,
  onMenuClick,
  showConnectionStatus = true
}) {
  return (
    <AppBar position="fixed" style={{ backgroundColor: '#3f51b5', zIndex: 1100 }}>
      <Toolbar>
        {showMenuButton && (
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={onMenuClick}
          >
            <MenuIcon />
          </IconButton>
        )}

        <Typography variant="h6" style={{ flexGrow: 1 }}>
          DriverApp
        </Typography>

        {showConnectionStatus && (
          <ConnectionStatus style={{ marginRight: 16 }} />
        )}

        <IconButton color="inherit" aria-label="refresh" onClick={onRefreshClick}>
          <RefreshIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
